import { API_ENDPOINT } from "@/utils/misc";
import axios from "axios";

export const getPendingShiftRequests = () => {
  return axios.get(`${API_ENDPOINT()}/shift-requests/pending`);
};

export const getShiftRequestsHistory = (payload) => {
  return axios.get(`${API_ENDPOINT()}/shift-requests/history`, {
    params: payload,
  });
};

export const updateAction = (id, action) => {
  return axios.post(
    `${API_ENDPOINT()}/shift-requests/set-action/${id}?_method=PUT`,
    { action }
  );
};
